<template>
  <v-container>
    <v-container v-if="user" fill-height fluid>
      <v-row align="center" justify="center">
        <h1 class="basic--text">Hello {{ user.name }} {{ user.surname }} !</h1>
      </v-row>
      <v-row align="center" justify="center">
        <h2 class="basic--text">You are awesome!</h2>
      </v-row>
      <v-row
        class="mt-12 mb-6"
        style="padding-right: 70px"
        align="center"
        justify="center"
      >
        <v-img src="@/assets/awesome.svg" max-width="30%"> </v-img>
      </v-row>
      <v-row class="my-3" align="center" justify="center">
        <v-btn color="accent" outlined href="http://192.168.0.21:8083/docs/">
          <v-icon left> mdi-file-document </v-icon>
          DOCUMENTATION</v-btn
        >
      </v-row>
    </v-container>
    <status-info
      v-if="failed"
      :responseMessage="responseMessage"
      :filename="filename"
      :pending="false"
    ></status-info>

    <!-- <v-container v-if="user === ''" fill-height fluid>
            <v-row align="center" justify="center">
                    <h1>You are not logged in...</h1>
            </v-row>
            <v-row align="center" justify="center">
                <v-img
                src="../assets/void.svg"
                max-width="400">
                </v-img>
            </v-row>
            <v-row align="center" justify="center">
                <v-btn  href="/login" color="primary"
                >Login
                </v-btn>
            </v-row>
        </v-container> -->
  </v-container>
</template>

<script>
import axios from "axios";
import StatusInfo from "@/components/organisms/StatusInfo.vue";

export default {
  name: "Home",
  components: {
    StatusInfo,
  },
  data: () => ({
    user: "",
    responseMessage: "",
    filename: "server_down.svg",
    failed: false,
  }),
  async created() {},
  async mounted() {
    if (localStorage.getItem("user-id")) {
      try {
        const response = await axios.get(
          "api/user/" + localStorage.getItem("user-id") + "?"
        );
        this.user = response.data;
      } catch (error) {
        switch (error.response.status) {
          case 400:
            this.filename = "void.svg";
            this.failed = true;
            this.responseMessage = "Bad request, please contact TECH team!";
            break;
          case 401:
            //clear local storage, push to login
            localStorage.clear();
            this.$router.push("login");
            break;
          case 406:
            //clear local storage, push to login
            localStorage.clear();
            this.$router.push("login");
            break;
          case 403:
            this.filename = "403_forbidden.svg";
            this.failed = true;
            this.responseMessage = "You are forbidden to do this action!";
            break;
          case 404:
            this.filename = "empty.svg";
            this.failed = true;
            this.responseMessage = "Page not found...";
            break;
          case 500:
            this.filename = "server_down.svg";
            this.failed = true;
            this.responseMessage =
              "Internal server error, please contact TECH team!";
        }
      }
    } else {
      this.$router.push("login");
    }
    if (localStorage.getItem("homeRefresh")) {
      localStorage.removeItem("homeRefresh");
      this.$router.go();
    }
  },
};
</script>
